import { Form } from 'antd';
import React, { useState } from 'react';

const SelectBtns = ({
    data,
    form,
    name,
    required,
    errorMessage,
    defaultValue
}) => {
    const hasError = form.getFieldError(name)?.length > 0;

    const [selectedBtnVal, setSelectedBtnVal] = useState(null);

    const onBtnSelect = (value) => {
        if (form && name) {
            const currentVal = form.getFieldValue(name);
            if (currentVal === value) {
                setSelectedBtnVal(null);
                form.setFieldValue(name, null);
                form.validateFields([name]); // Trigger validation
            } else {
                setSelectedBtnVal(value);
                form.setFieldValue(name, value);
                form.validateFields([name]); // Trigger validation
            }
        }
    };

    return (
        <Form.Item name={name} label="" wrapperCol={{ span: 24 }} rules={[
            {
                required: required,
                message: errorMessage,
            }
        ]}>
            <div style={data.containerStyle} className={hasError ? "select-btn-error" : ""}>

                {
                    data.btns.map((btn, indx) => (
                        <div
                            className={`${selectedBtnVal === btn.value ? "select-btn-selected" : "select-btn"}`}
                            style={{
                                ...btn.style

                            }} key={`select-btn-${indx}`} onClick={() => onBtnSelect(btn.value)}>
                            {btn.text}
                        </div>
                    ))
                }
            </div>

        </Form.Item>
    )
};

export default SelectBtns;